"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _antd = require("antd");
var _react = _interopRequireDefault(require("react"));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var InputNumberPlus = function InputNumberPlus(_ref) {
  var value = _ref.value,
    onChange = _ref.onChange,
    min = _ref.min,
    max = _ref.max,
    style = _ref.style;
  return /*#__PURE__*/_react.default.createElement("div", {
    style: _objectSpread({
      display: 'flex',
      width: 200
    }, style)
  }, /*#__PURE__*/_react.default.createElement(_antd.Slider, {
    style: {
      flex: '0 0 120px',
      marginRight: 12
    },
    value: value,
    min: min,
    max: max,
    onChange: onChange
  }), /*#__PURE__*/_react.default.createElement(_antd.InputNumber, {
    value: value,
    min: min,
    max: max,
    onChange: onChange,
    style: {
      flex: 1
    }
  }));
};
var _default = exports.default = InputNumberPlus;